import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["totalDisplay", "totalHidden"]
    static values = { newUrl: String }

    connect() {
        //this.computeTotal() Removed this since total is saved to db so no need to compute during connect
    }


    copy(event) {
        const revised_offer_number = event.target.value
        if (!revised_offer_number) return
        const a = document.getElementById("copy_link")
        const url = new URL(a.href, window.location.origin)
        url.searchParams.set("revised_offer_number", revised_offer_number)
        a.href = url.toString()
        a.click() // Turbo loads into main_frame
    }
    computeTotal() {
        let subtotal = 0
        const rows = this.element.querySelectorAll("#quotation-lines-table tr")

        rows.forEach(row => {
            const destroyInput = row.querySelector('input[name$="[_destroy]"], input[data-destroy-field]')
            if (destroyInput && destroyInput.value === "1") return

            // 🔹 Skip member rows (children of a group)
            if (row.hasAttribute("data-parent-dom")) return

            if (row.classList.contains("hidden") || row.getAttribute("aria-hidden") === "true") return

            const field = row.querySelector("[data-quotation-lines-row-target='subtotalField']")
            const value = parseFloat(field?.value || "0")
            if (!Number.isNaN(value)) subtotal += value
        })

        // Update displayed subtotal (optional UI)
        if (this.hasTotalDisplayTarget) this.totalDisplayTarget.textContent = `${subtotal.toFixed(2)}`

        // Set hidden subtotal for persistence and discount reference
        const subtotalHidden = this.element.querySelector('[data-quotation-target="subtotalHidden"]')
        if (subtotalHidden) subtotalHidden.value = subtotal.toFixed(2)

        // Initialize total = subtotal by default (before discounts)
        if (this.hasTotalHiddenTarget) this.totalHiddenTarget.value = subtotal.toFixed(2)
        const discountElement = this.element.querySelector("[data-controller~='discount']")
        if (!discountElement) return

        const discountController =
            this.application.getControllerForElementAndIdentifier(discountElement, "discount")

        if (discountController?.shouldApply?.()) {
            discountController.apply()
        }
    }
}